import React, { useEffect, useLayoutEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import airconhistorystatusService from "../services/airconhistorystatus.service";
import { Airconhistorystatusvalidationschema } from "../components/Validation";
import ReactPaginate from "react-paginate";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";
import Loader from "../components/Loader";
import Toastmessage from "../components/Toastmessage";
import { useNavigate, Link } from "react-router-dom";
import Alertmsg from "../components/Alertmsg";
import authsService from "../services/auths.service";
import categoryService from "../services/category.service";
import Reactsignatureconvas from "../components/Reactsignatureconvas";
const Airconhistorystatusy = (props) => {
  const [show, setShow] = useState(false);
  const target = useRef(null);
  const userinfo = authsService.userinfo();
  const userinfos = authsService.userdata();

  const ref = useRef();
  let navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [ismessage, setIsmessage] = useState("");
  const [eventname, setEventname] = useState("create");

  const [airconhistorystatuss, setAirconhistorystatuss] = useState([]);
  const [statuscategorys, setStatuscategorys] = useState([]);

  const [result, setResult] = useState([]);
  //smart table data
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(50);
  const [filter, setFilter] = useState(props.ah_id ? props.ah_id : "hfuhduf");
  const [search, setSearch] = useState("");
  const [between, setBetween] = useState("");
  const [sort, setSort] = useState("createdAt ASC");
  const [group, setGroup] = useState("");

  const [pagecount, setPagecount] = useState("");
  const [resultCount, setResultcount] = useState("");

  //table header arrays
  const tableHeaders = [
    { label: "airconhistorystatus ID", value: "" },
    { label: "airconhistorystatus name", value: "status_name" },
    { label: "Status", value: "status" },
    { label: "Created", value: "createdAt" },
    { label: "actions", value: "" },
  ];
  //filter arrays
  const statusfilterarr = [
    { status_id: "01", status_name: "pending" },
    { status_id: "02", status_name: "active" },
    { status_id: "03", status_name: "inactive" },
  ];
  const [filterarray, setFilterarray] = useState(statusfilterarr);
  //date range
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  };
  //form initial value
  const ahstatusformik = useFormik({
    initialValues: {
      status_id: "",
      ah_id: props.ah_id,
      status_name: props.ah_status,
      status_remark: "",
      approval_signature: "",
      created_type: userinfos.login_type,
      user_name: userinfo.user_name,
    },
    validationSchema: Airconhistorystatusvalidationschema,
    enableReinitialize: true,
    /*  validateOnChange: false,
         validateOnBlur: false, */
    onSubmit: (values, { resetForm }) => {
      /* resetForm({ values: "" }); */
    },
  });
  //use effects
  useEffect(() => {
    getallAirconhistorystatus();
    getallCategory();
    setEventname("create");
  }, []);
  /*   useLayoutEffect(() => {
      getallAirconhistorystatus();
    }, [page, limit, filter, search, between, sort]);
  */
  useLayoutEffect(() => {
    getallAirconhistorystatus();
  }, [props.ah_id]);

  //current event
  const airconhistorystatusEvent = (eventname, value) => {
    if (value != "") {
      getAirconhistorystatus(value);
      setEventname(eventname);
    }
    setEventname(eventname);
    ahstatusformik.resetForm();
  };
  const [createdType, setCreatedType] = useState("");
  //get allairconhistorystatus
  const getallAirconhistorystatus = async () => {
    setIsLoaded(true);
    var data = {
      limit: limit,
      page: page,
      filter: props.ah_id ? props.ah_id : "dfhhdgfhd",
      search: search,
      between: between,
      sort: sort,
      group: group,
    };
    return await airconhistorystatusService
      .getallAirconhistorystatus(data)
      .then((res) => {
        if (res.data.result) {
          setIsLoaded(false);
          setAirconhistorystatuss(res.data.result.data);
          setResult(res.data);
          setPage(res.data.result.page);
          setLimit(res.data.result.limit);
          setPagecount(res.data.result.pagecount);
          setResultcount(res.data.result.resultcount);
          setCreatedType(
            res.data.result.data[res.data.result.resultcount - 1].created_type
          );
          ahstatusformik.setFieldValue(
            "status_name",
            res.data.result.data[res.data.result.resultcount - 1]
              .status_name === "new case"
              ? "pending case"
              : res.data.result.data[res.data.result.resultcount - 1]
              .status_name === "pending case"
              ? "case approved"
              : res.data.result.data[res.data.result.resultcount - 1]
                .status_name === "case approved"
                ? "case closed"
                : res.data.result.data[res.data.result.resultcount - 1]
                  .status_name === "case closed"
                  ? "payment pending"
                  : res.data.result.data[res.data.result.resultcount - 1]
                    .status_name === "payment pending"
                    ? "payment closed"
                    : "completed"
          );
          console.log(res.data);
        } else {
          setIsLoaded(false);
          setAirconhistorystatuss(null);
          setAirconhistorystatuss([]);
        }
      })
      .catch((err) => {
        setAirconhistorystatuss([]);

        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //pagination
  const paginationfn = (event) => {
    setPage(event.selected + 1);
    console.log(event.selected + 1);
  };
  //search
  const searchfn = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };
  //filter
  const [filterArr, setfilterArr] = useState([]);
  const filterfn = (value) => {
    setPage(1);
    var index = filterArr.indexOf(value);
    if (index > -1) {
      filterArr.splice(index, 1);
      setFilter(filterArr.toString());
    } else {
      filterArr.push(value);
      setFilter(filterArr.toString());
    }
  };
  //sort
  const sortfn = (value) => {
    /*    setSort(value); */
    if (sort == value + " desc") {
      setSort(value + " asc");
      console.log(value + " asc");
    } else if (sort == value + " asc") {
      setSort("");
      console.log(value + "");
    } else {
      setSort(value + " desc");
      console.log(value + " desc");
    }
  };
  const betweenfn = async (date) => {
    await setStartDate(date.selection.startDate);
    await setEndDate(date.selection.endDate);
    setBetween(
      format(date.selection.startDate, "yyyy-MM-dd") +
      " , " +
      format(date.selection.endDate, "yyyy-MM-dd")
    );
  };
  //between
  const resetbetweenfn = () => {
    setBetween("");
    setStartDate(new Date());
    setEndDate(new Date());
  };
  const resetfilterfn = () => {
    setFilter("");
  };
  //get airconhistorystatus
  const getAirconhistorystatus = (value) => {
    setIsLoaded(true);
    airconhistorystatusService
      .getAirconhistorystatus(value)
      .then((res) => {
        if (res.data.result) {
          console.log(res.data);
          setIsLoaded(false);
          let data = res.data.result;
          ahstatusformik.setValues({
            status_id: data.status_id,
            ah_id: data.ah_id,
            status_name: data.status_name,
            status_remark: data.status_remark,
            created_type: data.created_type,
            user_name: userinfo.user_name,
          });
        } else {
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //create airconhistorystatus
  const createAirconhistorystatus = () => {
    airconhistorystatusService
      .createAirconhistorystatus(ahstatusformik.values)
      .then((res) => {
        console.log(res.data);
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("create");
          props.changefn();
          getallAirconhistorystatus();
          ahstatusformik.resetForm();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };

  //update airconhistorystatus
  const updateAirconhistorystatus = (value) => {
    console.log(JSON.stringify(ahstatusformik.values, null, 2));
    airconhistorystatusService
      .updateAirconhistorystatus(ahstatusformik.values)
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("view");
          getallAirconhistorystatus();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //delete airconhistorystatus
  const deleteAirconhistorystatus = (value) => {
    console.log(value);
    airconhistorystatusService
      .deleteAirconhistorystatus(String(value))
      .then((res) => {
        if (res.data.status) {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
          setEventname("create", "");
          ahstatusformik.resetForm();
          getallAirconhistorystatus();
        } else {
          ref.current.toastlog(res.data.status, res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //get allcategory
  const getallCategory = async () => {
    var data = {
      limit: 30,
      page: 1,
      filter: "",
      filtercategory: "case_status",
      search: "",
      between: "",
      sort: "category_rank ASC",
      group: "",
    };
    return await categoryService
      .getallCategory(data)
      .then((res) => {
        if (res.data.result) {
          setStatuscategorys(res.data.result.data);
        } else {
        }
      })
      .catch((err) => { });
  };
  const getsignature = (value) => {
    ahstatusformik.setFieldValue("approval_signature", value);
    /*  console.log(value); */
  };
  const selectedcolor = (value) => {
    if (value === "active") {
      return "badge rounded-pill bg-success";
    } else if (value === "pending") {
      return "badge rounded-pill bg-warning ";
    } else if (value === "inactive") {
      return "badge rounded-pill bg-danger";
    } else {
      return "badge rounded-pill bg-dark";
    }
  };
  // Call airconhistorystatus clicks to request another page.
  if (ismessage === "Network Error") {
    return <Alertmsg alertmsg={ismessage} type={false} />;
  }
  return (
    <div className="">
      <div className="">
        {/*  loader and error handler */}
        {<Toastmessage ref={ref} />}
        {isLoaded ? <Loader /> : <></>}
      </div>
      {/*  container */}
      <div className="airconhistorystatus-container">
        {/* airconhistorystatus form */}
        <div className="card border-0 mb-2">
          <div className="card-body ">
            <div className=" mb-2">
              {/* table data */}
              {airconhistorystatuss ? (
                <div>
                  {airconhistorystatuss.map((data, index) => (
                    <div className="border rounded p-1 mb-2" key={index}>
                      <div className="text-capitalize d-flex flex-wrap">
                        <div className="flex-fill">
                          <span>
                            {" "}
                            &nbsp;
                            <i className="fa fa-check-circle-o"></i>
                          </span>
                          &nbsp;{data.status_name}
                        </div>
                        { }
                        <div
                          className={
                            userinfos.login_type === "dashboard"
                              ? "d-block"
                              : "d-none"
                          }
                        >
                          <a
                            onClick={() => {
                              airconhistorystatusEvent("edit", data.status_id);
                            }}
                            className="btn btn-sm"
                          >
                            <i className="fa fa-pencil-square-o"></i>
                          </a>
                          <a
                            onClick={() => {
                              airconhistorystatusEvent(
                                "delete",
                                data.status_id
                              );
                            }}
                            className="btn btn-sm"
                          >
                            <i className="fa fa-trash-o"></i>
                          </a>
                        </div>
                      </div>
                      <div className="">
                        <span
                          style={{ fontSize: 12 }}
                          className="  text-secondary"
                        >
                          Created By:{data.createdBy},&nbsp;Created Date:
                          {format(new Date(data.createdAt), "PPpp")}
                          {/*  <button
                            className="btn btn-sm"
                            ref={target}
                            onClick={() => setShow(!show)}
                          >
                            <i className="fa fa-info-circle"></i>
                          </button> */}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center p-3">0 data found</div>
              )}
            </div>
            <div className="d-flex">
              {/* <h5 className="card-title p-0 m-0 me-auto">
                Airconhistorystatus
              </h5> */}
              {eventname == "create" ? (
                <></>
              ) : (
                <div className="d-none">
                  <div className="dropdown ">
                    <a
                      className="btn  btn-link"
                      href="#"
                      role="button"
                      id="airconhistorystatuseventdropdownMenuLink"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </a>
                    <ul
                      className="dropdown-menu"
                      aria-labelledby="airconhistorystatuseventdropdownMenuLink"
                    >
                      <li>
                        <a
                          onClick={() => {
                            airconhistorystatusEvent("edit", "");
                          }}
                          className="dropdown-item"
                        >
                          Edit
                        </a>
                      </li>
                      <li>
                        <a
                          onClick={() => airconhistorystatusEvent("delete", "")}
                          className="dropdown-item"
                        >
                          Delete
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
            <form onSubmit={ahstatusformik.handleSubmit}>
              <div className="row">
                {ahstatusformik.values.status_name === "completed" ? (
                  <></>
                ) : (
                  <>
                    <div className="col-md-12">
                      <label htmlFor="status_name" className="form-label">
                        {/* status */}
                      </label>
                      <div className="input-group col-md-6">
                        <select
                          id="status_name"
                          {...ahstatusformik.getFieldProps("status_name")}
                          className="form-select"
                          aria-label="status_name"
                          disabled={
                            eventname == "view"
                              ? true
                              : eventname == "create"
                                ? true
                                : eventname == "delete"
                                  ? true
                                  : false
                          }
                        >
                          <option value="" disabled>
                            Select status
                          </option>
                          {statuscategorys.map((statuscategorys, index) => (
                            <option
                              key={index}
                              value={statuscategorys.category_name}
                            >
                              {statuscategorys.category_name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div>
                        {ahstatusformik.touched.status_name &&
                          ahstatusformik.errors.status_name ? (
                          <div className="error">
                            {ahstatusformik.errors.status_name}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {createdType != userinfos.login_type &&
                      ahstatusformik.values.status_name === "case approved" ? (
                      <div className="col-md-12 ">
                        <div className="border rounded mt-2">
                          <div className="text-center text-secondary">
                            Signature.
                          </div>
                          <div className="pt-2 pb-2">
                            <Reactsignatureconvas signatuterfn={getsignature} />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                   {/*  {eventname === "create" ? (
                      createdType != userinfos.login_type &&
                        ahstatusformik.values.status_name ===
                        "case approved" ? (
                        <>

                        </>
                      ) : userinfos.login_type === "technition" &&
                        ahstatusformik.values.status_name !=
                        "case approved" &&
                        ahstatusformik.values.status_name !=
                        "payment closed" ? (
                        <>

                        </>
                      ) : userinfos.login_type === "dashboard" &&
                        ahstatusformik.values.status_name != "sdsdfsdfs" ? (
                        <>

                        </>
                      ) : (
                        <></>
                      )
                    ) : <></>} */}



                    <div className="col-md-12 ">
                      <label htmlFor="status_remark" className="form-label">
                        {/* Remark */}
                      </label>
                      <div className="input-group">
                        <textarea
                          className="form-control"
                          placeholder="Enter remark"
                          id="status_remark"
                          disabled={
                            eventname == "view"
                              ? true
                              : eventname == "delete"
                                ? true
                                : false
                          }
                          {...ahstatusformik.getFieldProps("status_remark")}
                        ></textarea>
                      </div>
                      <div>
                        {ahstatusformik.touched.status_remark &&
                          ahstatusformik.errors.status_remark ? (
                          <div className="error">
                            {ahstatusformik.errors.status_remark}
                          </div>
                        ) : null}
                      </div>
                    </div>
                    {/* airconhistorystatus event buttons */}
                    <div className="col-md-12 pt-2 pb-2">
                      {eventname === "create" ? (
                        createdType != userinfos.login_type &&
                          ahstatusformik.values.status_name ===
                          "case approved" ? (
                          <>
                            <button
                              disabled={
                                !ahstatusformik.isValid || !ahstatusformik.dirty
                              }
                              onClick={() => createAirconhistorystatus()}
                              className="btn btn-primary me-2"
                            >
                              Submit
                            </button>
                          </>
                        ) : userinfos.login_type === "technition" &&
                        ahstatusformik.values.status_name !=
                          "new case" &&
                          ahstatusformik.values.status_name !=
                          "case approved" &&
                          ahstatusformik.values.status_name !=
                          "payment closed" ? (
                          <>
                            <button
                              disabled={
                                !ahstatusformik.isValid || !ahstatusformik.dirty
                              }
                              onClick={() => createAirconhistorystatus()}
                              className="btn btn-primary me-2"
                            >
                              Submit
                            </button>
                          </>
                        ) : userinfos.login_type === "dashboard" &&
                          ahstatusformik.values.status_name != "sdsdfsdfs" ? (
                          <>
                            <button
                              disabled={
                                !ahstatusformik.isValid || !ahstatusformik.dirty
                              }
                              onClick={() => createAirconhistorystatus()}
                              className="btn btn-primary me-2"
                            >
                              Submit
                            </button>
                          </>
                        ) : (
                          <></>
                        )
                      ) : eventname === "edit" ? (
                        <>
                          <button
                            onClick={() => updateAirconhistorystatus()}
                            className="btn btn-primary me-2"
                          >
                            Update
                          </button>
                          <a
                            onClick={() => {
                              airconhistorystatusEvent("create", "");
                              ahstatusformik.handleReset();
                            }}
                            className="btn btn-secondary"
                          >
                            Cancel
                          </a>
                        </>
                      ) : eventname === "delete" ? (
                        <>
                          <button
                            onClick={() =>
                              deleteAirconhistorystatus(
                                ahstatusformik.values.status_id
                              )
                            }
                            className="btn btn-danger me-2 "
                          >
                            Delete
                          </button>
                          <a
                            onClick={() => {
                              airconhistorystatusEvent("create", "");
                              ahstatusformik.handleReset();
                            }}
                            className="btn btn-secondary"
                          >
                            Cancel
                          </a>
                        </>
                      ) : (
                        <>
                          <button
                            onClick={() => {
                              airconhistorystatusEvent("create", "");
                              ahstatusformik.handleReset();
                            }}
                            className="btn btn-primary"
                          >
                            Close
                          </button>
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Airconhistorystatusy;
